import {useMemo} from "react";
import {findPatternId} from "./Svg-utils";

export const useSvgContent = (svgEncodedBase64: string, sectionId: string) => {
    return useMemo(() => {
        const svg = atob(svgEncodedBase64);
        const id = findPatternId(svg);

        return id
            ? svg.replace(id, `${sectionId}`).replaceAll('xlink:href="/*url*/"', '')
            : null;

    }, [svgEncodedBase64, sectionId])
}
